import { Component, ViewChild, inject, AfterViewInit, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { CreateAdventureModalComponent } from 'src/app/components/base-modal/create-adventure-modal/create-adventure-modal.component';
import { CreateItemModalComponent } from 'src/app/components/base-modal/create-item-modal/create-item-modal.component';
import {
  CatalogItemExtended
} from 'src/app/core/models/catalog/catalog-item.model';
import { ModalService } from 'src/app/core/services/modal/modal.service';
import { WindowService } from 'src/app/core/services/window/window.service';
import { CatalogState } from 'src/app/core/store/catalog.reducer';
import { RouterModule } from '@angular/router';
import { TextInputComponent } from 'src/app/components/form/text-input/text-input.component';
import { TextAreaInputComponent } from 'src/app/components/form/text-area-input/text-area-input.component';
import { ButtonComponent } from 'src/app/components/user-interface/button/button.component';
import { ToggleComponent } from 'src/app/components/form/toggle/toggle.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-playground',
  templateUrl: './playground.component.html',
  styleUrls: ['./playground.component.scss'],
  standalone: true,
  imports: [
    RouterModule,
    ReactiveFormsModule,
    TextInputComponent,
    TextAreaInputComponent,
    ButtonComponent,
    ToggleComponent,
    CommonModule
  ],
})
export class PlaygroundComponent implements AfterViewInit, OnInit {
  private store = inject<Store<CatalogState>>(Store);
  private modalService = inject(ModalService);
  private windowService = inject(WindowService);

  @ViewChild('createUniverseModal')
  createUniverseModal!: CreateItemModalComponent;
  dynamicLink;
  @ViewChild('createAdventureModal')
  createAdventureModal!: CreateAdventureModalComponent;

  openUniverseDialog() {
    this.createUniverseModal.openDialog();
  }

  openAdventureDialog() {
    this.createAdventureModal.openDialog();
  }

  publishForm = new FormGroup({
    title: new FormControl('', [
      Validators.required,
      Validators.maxLength(210),
      Validators.minLength(300),
    ]),
    description: new FormControl('', [
      Validators.required,
      Validators.maxLength(240),
    ]),
    asTemplate: new FormControl(false),
    banner: new FormControl(''),
    priceCheck: new FormControl({ value: false, disabled: true }),
    price: new FormControl({ value: '', disabled: true }, Validators.required),
    mature: new FormControl(false),
    violence: new FormControl(false),
  });

  onSubmit() {
    this.publishForm.controls['title'].setErrors({
      NotFound: true,
      Unavailable: true,
    });

    console.log(this.publishForm.value);
  }
  list = true;
  items: CatalogItemExtended[] = [
    {
      item: {
        Id: '448393fa-5231-457e-a677-f64d91594d5e',
        Type: 'ugc',
        AlternateIds: [],
        Title: {
          NEUTRAL: 'New Universe 123321',
        },
        Description: {
          NEUTRAL: '1',
        },
        Keywords: {},
        ContentType: 'Universe',
        CreatorEntity: {
          Id: 'A4C89F124385663',
          Type: 'title_player_account',
          TypeString: 'title_player_account',
        },
        Platforms: [],
        Tags: [],
        CreationDate: '2023-09-28T13:45:48.656Z',
        LastModifiedDate: '2023-09-28T13:45:48.656Z',
        StartDate: '2023-09-28T13:45:48.656Z',
        Contents: [],
        Images: [],
        ItemReferences: [],
        DeepLinks: [],
        DisplayProperties: {},
        ETag: '"17007cce-0000-0300-0000-6515838c0000"',
      },
      data: {
        type: 'draft',
      },
    },
    {
      item: {
        Id: 'b6303b58-7014-4b88-ac3c-64d3ca956447',
        Type: 'ugc',
        AlternateIds: [],
        Title: {
          NEUTRAL: 'New Universe 12121',
        },
        Description: {
          NEUTRAL: '1111',
        },
        Keywords: {},
        ContentType: 'Universe',
        CreatorEntity: {
          Id: 'A4C89F124385663',
          Type: 'title_player_account',
          TypeString: 'title_player_account',
        },
        Platforms: [],
        Tags: [],
        CreationDate: '2023-09-28T13:47:31.162Z',
        LastModifiedDate: '2023-09-28T13:47:31.162Z',
        StartDate: '2023-09-28T13:47:31.162Z',
        Contents: [],
        Images: [],
        ItemReferences: [],
        DeepLinks: [],
        DisplayProperties: {},
        ETag: '"170050eb-0000-0300-0000-651583f30000"',
      },
      data: {
        type: 'draft',
      },
    },
    {
      item: {
        Id: 'fcc4351a-f4e3-4941-8678-9bac4e7f09e6',
        Type: 'ugc',
        AlternateIds: [],
        Title: {
          NEUTRAL:
            'This is a very long game title long very long words many words',
        },
        Description: {
          NEUTRAL: 'a',
        },
        Keywords: {},
        ContentType: 'Universe',
        CreatorEntity: {
          Id: 'A4C89F124385663',
          Type: 'title_player_account',
          TypeString: 'title_player_account',
        },
        Platforms: [],
        Tags: [],
        CreationDate: '2023-09-28T14:12:00.312Z',
        LastModifiedDate: '2023-09-28T14:12:00.312Z',
        StartDate: '2023-09-28T14:12:00.312Z',
        Contents: [],
        Images: [],
        ItemReferences: [],
        DeepLinks: [],
        DisplayProperties: {},
        ETag: '"190033c0-0000-0300-0000-651589b00000"',
      },
      data: {
        type: 'draft',
      },
    },
    {
      item: {
        Id: '66c85c8a-ea4a-4633-95f4-fe80e28e1487',
        Type: 'ugc',
        AlternateIds: [],
        Title: {
          NEUTRAL: 'New adventure',
        },
        Description: {
          NEUTRAL: '1234312123',
        },
        Keywords: {},
        ContentType: 'Adventure',
        CreatorEntity: {
          Id: 'A4C89F124385663',
          Type: 'title_player_account',
          TypeString: 'title_player_account',
        },
        Platforms: [],
        Tags: [],
        CreationDate: '2024-05-10T20:27:46.16Z',
        LastModifiedDate: '2024-05-10T20:27:46.16Z',
        StartDate: '2024-05-10T20:27:46.16Z',
        Contents: [],
        Images: [],
        ItemReferences: [],
        DeepLinks: [],
        DisplayProperties: {
          ParentUniverseID: 'fcc4351a-f4e3-4941-8678-9bac4e7f09e6',
        },
        ETag: '"0e00f247-0000-0800-0000-663e83420000"',
      },
      data: {
        type: 'draft',
      },
    },
    {
      item: {
        Id: '97d436d5-e586-4e0d-8027-860c6fe98732',
        Type: 'ugc',
        AlternateIds: [],
        Title: {
          NEUTRAL: '423555',
        },
        Description: {
          NEUTRAL: '5555536',
        },
        Keywords: {},
        ContentType: 'Adventure',
        CreatorEntity: {
          Id: 'A4C89F124385663',
          Type: 'title_player_account',
          TypeString: 'title_player_account',
        },
        Platforms: [],
        Tags: [],
        CreationDate: '2024-05-10T20:28:10.951Z',
        LastModifiedDate: '2024-05-10T20:28:10.951Z',
        StartDate: '2024-05-10T20:28:10.951Z',
        Contents: [],
        Images: [
          {
            Id: '7e64a6ea-26e7-4dfa-95a6-cddba05a5079',
            Tag: 'Thumbnail',
            Type: 'Thumbnail',
            Url: 'https://pfcatalogcontent1.blob.core.windows.net/pf-title-db4f2c0f7455c5d5-51498/7e64a6ea-26e7-4dfa-95a6-cddba05a5079/Welcome_banner-2.png?sv=2023-11-03&st=2024-05-10T20%3A15%3A30Z&se=2024-05-10T21%3A30%3A30Z&sr=b&sp=r&rscc=private&sig=NEVxamb1K5YGLgeDnmTyWsP13sS%2BVLOBcnHvbKma9g8%3D',
          },
        ],
        ItemReferences: [],
        DeepLinks: [],
        DisplayProperties: {
          ParentUniverseID: 'fcc4351a-f4e3-4941-8678-9bac4e7f09e6',
        },
        ETag: '"0e00554a-0000-0800-0000-663e835b0000"',
      },
      data: {
        type: 'draft',
      },
    },
  ];
  ngAfterViewInit() {
    // this.modalService.openAdventureModal({
    //   item: this.items[1].item,
    //   parentItem: this.items[0],
    //   inventory: true,
    // });
  }

  ngOnInit() {
    const fullUrl = '/news/carlos?t=234'; // This should come from your CMS
    const win = this.windowService.getWindow();
    const origin = win?.location.origin ?? '';
    const url = new URL(fullUrl, origin);

    this.dynamicLink = {
      path: [url.pathname],
      queryParams: Object.fromEntries(url.searchParams),
    };
  }
}
